import { makeApiCall } from '../../services/api'

export function createTrip() {
  return makeApiCall(`/ooo-reimbursement`, 'POST')
}
export function getTripList() {
  return makeApiCall(`/ooo-reimbursement`, 'GET')
}
